import { render } from "./Water_meters.vue?vue&type=template&id=72873ca2"
import script from "./Water_meters.vue?vue&type=script&lang=js"
export * from "./Water_meters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__